import React, { useRef, useEffect, useState } from 'react';

import './index.scss';

const ClientItem = ({ className, photo, title, link }) => {
  return (
    <div className={`client-item ${className ? className : ''}`}>
      {
        link ?
        <a href={ link } className="cover" target="_blank">
          <img className="image" src={ photo } alt={title} />
          <div className="circle"></div>
        </a>
        :
        <div className="cover">
          <img className="image" src={ photo } alt={title} />
          <div className="circle"></div>
        </div>
      }
    </div>
  )
}

export default ClientItem;